import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import getGlobalState from '../helpers/getGlobal';
import { Locale, UserState } from '../interfaces/user/user';

const initialState: UserState = {
  ...getGlobalState(),
  locale: 'es_ES' as Locale,
  currentUser: null,
  configThoughtSpot: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserItem(state, action: PayloadAction<Partial<UserState>>) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setUserItem } = userSlice.actions;

export default userSlice.reducer;
